import { Directive } from '@angular/core';

/**
 * Directive used to pass the template to be used to render a slide in the CarouselComponent
 */
@Directive({
  selector: 'ng-template[atxCarouselSlide]',
  standalone: false,
})
export class CarouselSlideDirective {}
